import React  from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import noop from 'lodash/noop';
import themeable from 'zignal-landscape/lib/themeable';
import Checkbox from 'zignal-landscape/lib/Checkbox';
import Label from 'zignal-landscape/lib/Label';
import Link from 'zignal-landscape/lib/Link';

const ActionsMenu = ({
  styles,
  children,
  onSelectAllChange = noop,
  selectAllChecked,
  isVisible,
  onCancel
}) => {
  const actionsMenuClasses = {
    [styles.CustomActionsMenu]: true,
    [styles.isVisible]: isVisible
  };
  return (
    <div className={classnames(actionsMenuClasses)}>
      <div className={styles.selectAll}>
        <Checkbox
          id="StoryListActionsSelectAll"
          name="StoryListActionsSelectAll"
          checked={selectAllChecked}
          onChange={(e) => onSelectAllChange(e.target.checked)}
        />
        <Label htmlFor="StoryListActionsSelectAll" inline>Select All</Label>
      </div>
      <div className={styles.storiesTableActionsMenuItemsWrapper}>
        <div className={styles.storiesTableActionsMenuItems}>
          {children}
        </div>
      </div>
      <div className={styles.close}>
        <Link linkType="cancel" onClick={onCancel}>Cancel</Link>
      </div>
    </div>
  );
};

ActionsMenu.propTypes = {
  styles: PropTypes.object.isRequired,
  children: PropTypes.element.isRequired,
  onSelectAllChange: PropTypes.func,
  onCancel: PropTypes.func,
  selectAllChecked: PropTypes.bool,
  isVisible: PropTypes.bool
};

export default themeable(ActionsMenu);
